// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b2a48aa3","310":"bb9d754e","453":"60ad7219","455":"3f85bdfd","631":"a86b97e0","666":"9f5ec9e2","764":"684a4e74","900":"502e1273"}[chunkId] + ".chunk.js";
};